import CitySEOHead from "@/components/feature/CitySEOHead";
import LakewoodRanchHeroSection from "./components/HeroSection";
import LakewoodRanchStickyNav from "./components/StickyNav";
import LakewoodRanchProcessingTimeSection from "./components/ProcessingTimeSection";
import LakewoodRanchServicesSection from "./components/ServicesSection";
import LakewoodRanchLocalAreaSection from "./components/LocalAreaSection";
import LakewoodRanchTravelTimingSection from "./components/TravelTimingSection";
import LakewoodRanchDestinationsSection from "./components/DestinationsSection";
import LakewoodRanchTestimonialsSection from "./components/TestimonialsSection";
import LakewoodRanchAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LakewoodRanchComparisonSection from "./components/ComparisonSection";
import LakewoodRanchMistakesSection from "./components/MistakesSection";
import LakewoodRanchHowItWorksSection from "./components/HowItWorksSection";
import LakewoodRanchFAQSection, { faqs } from "./components/FAQSection";
import LakewoodRanchHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LakewoodRanchFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const lakewoodRanchServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function LakewoodRanchPage() {
  return (
    <div className="min-h-screen bg-white">
      <CitySEOHead
        city="Lakewood Ranch"
        state="Florida"
        stateAbbr="FL"
        route="/cities/lakewood-ranch"
        title="Emergency Passport Lakewood Ranch, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Lakewood Ranch, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Sarasota and Manatee County families, golf travelers, and school trip organizers."
        geoPlacename="Lakewood Ranch, Florida"
        geoPosition="27.4505;-82.4315"
        faqs={faqs}
        servicesSchema={lakewoodRanchServices}
        statePageName="Florida"
        statePageRoute="/states/florida"
      />
      <LakewoodRanchHeroSection />
      <LakewoodRanchStickyNav />
      <LakewoodRanchProcessingTimeSection />
      <LakewoodRanchServicesSection />
      <LakewoodRanchLocalAreaSection />
      <LakewoodRanchTravelTimingSection />
      <LakewoodRanchDestinationsSection />
      <LakewoodRanchTestimonialsSection />
      <LakewoodRanchAcceptanceFacilitiesSection />
      <LakewoodRanchComparisonSection />
      <LakewoodRanchMistakesSection />
      <LakewoodRanchHowItWorksSection />
      <LakewoodRanchFAQSection />
      <LakewoodRanchHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/lakewood-ranch" state="FL" />
      <LakewoodRanchFinalCTA />
    </div>
  );
}